import { Company } from "../_types/company";

export const locales = ['en', 'sq', 'de', 'fr', 'es', 'ar'];

// to add meta
export const companiesList: Company[] = [
    {
        id: 'gss',
        base_url: 'http://192.168.1.23/',
        name: 'General Swiss Services',
        logo: '/images/gss_logo.png',
        emails: ['contact@gsservices.ch'],
        phone_numbers: ['+41 22 313 70 81', '+41 78 209 39 48'],
        address_line1: 'Chemin de la Fontaine 2',
        address_line2: '1224 Chêne-Bougeries',
        address_line3: 'Geneva, Switzerland',
        socials: [
            {
                name: 'Facebook',
                link: 'https://www.facebook.com/p/General-Swiss-Services-Sàrl-100064811653228/'
            },
            {
                name: 'Instagram',
                link: 'https://www.instagram.com/generalswissservices/'
            }
        ],
        colors: {
            primary: '#000',
            secondary: '#C91B31',
            background: '#fff',
            text: '#000'
        },
        font: 'Outfit'
    },
]